module.exports = __webpack_public_path__ + "static/media/graph.3a535701.svg";